/* js bundle for marketing pages built with brand2025 design */
import * as Sentry from "@sentry/browser"
import {CategoryReviews, ReviewsApp, ReviewsBreakdown, AggregateStars} from "./components/category_reviews"
import {CategorySubnav} from "./components/category_subnav"
import {FAQs} from "./components/faqs"
import {Accordions} from "./components/accordions"
import {ExternalReviews} from "./components/external_reviews.js"
import {Header} from "./components/header"
import {HorizontalScroller} from "./components/horizontal_scroller"
import {ProjectManagers} from "./components/project_managers"
import {ReviewsCarousel} from "./components/reviews_carousel"
import {ScrollTransitions} from "./components/scroll_transitions"
import {SimpleBox} from "@wfleming/simplebox"
import {Tabs} from "./components/tabs"
import {listenForTrackEvents, trackEventSP} from "js/studios/shared/tracking"
import {onPageReady} from "js/studios/shared/utils"
import {initializeSentry} from "js/studios/shared/sentry"

initializeSentry(Sentry)

function setupAnalytics() {
  listenForTrackEvents()  // data-track-event-sp attr support

  // normal links without any data attrs trigger click_body_link events.
  document.body.addEventListener("click", ev => {
    if (ev.target.tagName === "A" && Object.keys(ev.target.dataset).length === 0) {
      trackEventSP("click_body_link", "browse", {label: ev.target.textContent.trim() || ev.target.href})
    }
  })

  // get started CTAs - annotate with data-primary-cta
  // (css class .consultation_cta no longer supported, pages ported to brand2025 should change to data)
  for (const a of document.querySelectorAll("[data-primary-cta]")) {
    a.addEventListener("click", ev => {
      trackEventSP("click_primary_cta", "lead_capture", {
        button_location: ev.target.dataset.location,
        call_to_action: ev.target.textContent.trim(),
      })
    })
  }

  // footer links get distinct analytics event names
  for (const a of document.querySelectorAll("footer a")) {
    a.addEventListener("click", ev => {
      trackEventSP("click_footer_item", "browse", {
        label: ev.currentTarget.textContent.trim() || ev.currentTarget.title || ev.currentTarget.href,
      })
    })
  }
}

const COMPONENT_CLASSES = [
  Accordions,
  AggregateStars,
  CategoryReviews,
  CategorySubnav,
  ExternalReviews,
  FAQs,
  Header,
  HorizontalScroller,
  ProjectManagers,
  ReviewsApp,
  ReviewsBreakdown,
  ReviewsCarousel,
  Tabs,
]

function setupComponents() {
  window.cm ||= {}
  window.cm.components = []

  for (const Component of COMPONENT_CLASSES) {
    for (const el of document.querySelectorAll(Component.selector)) {
      window.cm.components.push(new Component(el))
    }
  }

  // ScrollTransitions works a bit differently, taking a list of every element rather than
  // creating a separate instance for each element so we have fewer scroll event listeners, which
  // can impact performance.
  window.cm.components.push(new ScrollTransitions(document.querySelectorAll(ScrollTransitions.selector)))
}

onPageReady(() => {
  setupAnalytics()
  SimpleBox({selector: "[data-lightbox]"})
  setupComponents()
})
